// extracted by mini-css-extract-plugin
export default {"img-container__original":"Movie_img-container__original__EkJ7m","movie-img":"Movie_movie-img__wN0ZD","img-container__types":"Movie_img-container__types__fsFEI"};